import { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import AddProfilesSummaryGridModel from "../../../models/company/addProfiles/response/AddProfilesSummaryGridModel";
import addProfilesService from "../../../services/company/add-profiles-service";
import toasterUtils from "../../../utils/toaster-utils";
import dateTimeUtils from "../../../utils/date-utils";
import AddProfilesSummarySearchInputModel from "../../../models/company/addProfiles/request/AddProfilesSummarySearchInputModel";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

interface RequirementSummaryProps {
    requirementId: string;
};

const SummaryGridDefault = {
    requirementId: "",
    noOfProfilesReceived: "",
    noOfInterviewsCompleted: "",
    noOfInterviewsScheduled: "",
    noOfCandidatesWithRatingAbove3: "",
    noOfCandidatesWithRatingUnder3: "",
    noOfNoResponses: ""
};

const RequirementSummaryGridComponent = (props: RequirementSummaryProps) => {
    const [summaryData, setSummaryData] = useState<AddProfilesSummaryGridModel>(SummaryGridDefault);
    const [refreshSummary, setRefreshSummary] = useState<number>(2);
    const [startDateSearch, setStartDateSearch] = useState<Dayjs | null>(dayjs().subtract(7, 'day'));
    const [endDateSearch, setEndDateSearch] = useState<Dayjs | null>(dayjs());

    useEffect(() => {
        getRequirementSummary();
    }, []);

    const getRequirementSummary = () => {
        setRefreshSummary(2);
        //modalUtils.showLoader();
        let searchData: AddProfilesSummarySearchInputModel = {
            requirementId: props.requirementId,
            startDate: dateTimeUtils.getFormattedDate(startDateSearch ? startDateSearch.toDate() : new Date()),
            endDate: dateTimeUtils.getFormattedDate(endDateSearch ? endDateSearch.toDate() : new Date())
        };
        addProfilesService.getRequirementSummary(searchData).then((res) => {
            //modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setSummaryData(res.data);
            setRefreshSummary(refreshSummary * 5);
        }).catch((error) => {
            //modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    const columnsSummary = [
        { key: "NoOfProfilesReceived", text: "No of Profiles Recieved", sort: false, searchable: false },
        { key: "NoOfInterviewsCompleted", text: "No of Interviews Completed", sort: false, searchable: false },
        { key: "NoOfInterviewsScheduled", text: "No of Interviews Scheduled", sort: false, searchable: false },
        { key: "NoOfCandidatesWithRatingAbove3", text: "No of Candidates with 3 and Above Rating", sort: false, searchable: false },
        { key: "NoOfCandidatesWithRatingUnder3", text: "No of Candidates with 2.5 to 2.9 Rating", sort: false, searchable: false },
        { key: "NoOfNoResponses", text: "No of No Responses", sort: false, searchable: false },
    ];

    return (
        <div>
            <div className="row">
                <div className="col-md-3">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Start Date"
                            value={startDateSearch}
                            onChange={(newValue) => setStartDateSearch(newValue)}
                            format="YYYY-MMM-DD"
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                    size: "small",
                                },
                            }}
                        />
                    </LocalizationProvider>
                </div>
                <div className="col-md-3">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="End Date"
                            value={endDateSearch}
                            onChange={(newValue) => setEndDateSearch(newValue)}
                            format="YYYY-MMM-DD"
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                    size: "small",
                                },
                            }}
                        />
                    </LocalizationProvider>
                </div>
                <div className="col-md-3">
                    <Button variant="contained" color="success" onClick={() => getRequirementSummary()} startIcon={<SearchIcon />}>
                        Search
                    </Button>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {columnsSummary.map((column: any) => (
                                        <TableCell key={column.key} className="table-header-cell">
                                            <span>{column.text}</span>
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell>{summaryData.noOfProfilesReceived}</TableCell>
                                    <TableCell>{summaryData.noOfInterviewsCompleted}</TableCell>
                                    <TableCell>{summaryData.noOfInterviewsScheduled}</TableCell>
                                    <TableCell>{summaryData.noOfCandidatesWithRatingAbove3}</TableCell>
                                    <TableCell>{summaryData.noOfCandidatesWithRatingUnder3}</TableCell>
                                    <TableCell>{summaryData.noOfNoResponses}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
        </div>
    );
};
export default RequirementSummaryGridComponent;